import React from 'react';
import Meta from 'src/components/Meta';
import { useGaEventPageView } from 'src/utils/gaEvent';
import styled from 'styled-components';
import { PageContainer } from 'src/common';
import V2 from './V2/V2';

const Div = styled(PageContainer)`
  .panel {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    grid-gap: 10px;
  }
`;

const InsightsPage = () => {
  useGaEventPageView('Cydea | Insights');

  return (
    <>
      <Meta title={`Cydea | Insights`} feedbackScript />
      <Div>
        <V2 />
      </Div>
    </>
  );
};

export default InsightsPage;
